import React, {useState} from 'react'
import {MenuButton as Button} from './style'
import { useScrollPosition } from "shared/Hooks/useScrollPosition"

export const MenuButton = ({active,light,menuButtonClicked})=>{
    const [blackOnScroll, setBlackOnScroll] = useState(false)
    const isBrowser = typeof window !== `undefined`
    useScrollPosition(({prevPos,currPos}) => {
        if(isBrowser) {
            if(currPos.y < -window.innerHeight && window.location.pathname !== '/kontakt') {
                setBlackOnScroll(true)
            }else {
                setBlackOnScroll(false)
            }
        }
    }, [blackOnScroll], false, false, 1000)
    return (       
        <Button onClick={menuButtonClicked} active={active} light={light || blackOnScroll }>
            MENU
        </Button>
    )
}